import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "tentang", label: "Tentang" },
  { id: "layanan", label: "Layanan" },
  { id: "proses", label: "Proses" },
  { id: "kontak", label: "Kontak" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F9F8F6]/95 backdrop-blur-md border-b border-[#E5E3DC]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <button
          onClick={() => handleNav("beranda")}
          data-testid="logo-button"
          className="flex items-center gap-3 text-left"
        >
          <span className="hp-divider" />
          <span className="font-serif text-xl tracking-tight text-[#1A2B29] leading-none">
            Helen Parlista
            <span className="block text-[10px] font-sans tracking-[0.3em] uppercase text-[#5C6B69] mt-1">
              Notaris &amp; PPAT
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => handleNav(n.id)}
              className="text-sm font-medium tracking-wide text-[#1A2B29] hover:text-[#C4A661] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => handleNav("kontak")}
          data-testid="header-cta"
          className="hidden lg:inline-flex btn-primary text-xs px-6 py-3"
        >
          Kontak
        </button>

        <button
          onClick={() => setOpen((s) => !s)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[#1A2B29]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#F9F8F6] border-t border-[#E5E3DC]"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => handleNav(n.id)}
                className="text-left text-base font-medium text-[#1A2B29] py-2"
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("kontak")}
              data-testid="mobile-cta"
              className="btn-primary justify-center mt-3"
            >
              Kontak
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
